var StringCleaner = require('./lib/string-cleaner'),
    TextCleaner = function TextCleaner(str, options) {
  return new StringCleaner(str, options);
};

TextCleaner.StringCleaner = StringCleaner;
module.exports = TextCleaner;